export class LandplotsLayers {
    http;
    constructor(http) {
        this.http = http;
    }
    getLandplotsLayers() {
        return this.http.get(`/api/landplots_layers`).json();
    }
}
